enum ContractDriverLicenseType {
  CLASS_1_ORDINARY = 1,
  CLASS_1_LARGE = 2,
  CLASS_1_SPECIAL = 3,

  CLASS_2_ORDINARY = 4,
  CLASS_2_SMALL = 5,
  CLASS_2_MOPED = 6,
}

export const allCases = [
  ContractDriverLicenseType.CLASS_1_ORDINARY,
  ContractDriverLicenseType.CLASS_1_LARGE,
  ContractDriverLicenseType.CLASS_1_SPECIAL,
  ContractDriverLicenseType.CLASS_2_ORDINARY,
  ContractDriverLicenseType.CLASS_2_SMALL,
  ContractDriverLicenseType.CLASS_2_MOPED,
];

export const name = (type: ContractDriverLicenseType) => {
  switch (type) {
    case ContractDriverLicenseType.CLASS_1_SPECIAL:
      return '1종 특수';
    case ContractDriverLicenseType.CLASS_1_LARGE:
      return '1종 대형';
    case ContractDriverLicenseType.CLASS_1_ORDINARY:
      return '1종 보통';
    case ContractDriverLicenseType.CLASS_2_ORDINARY:
      return '2종 보통';
    case ContractDriverLicenseType.CLASS_2_SMALL:
      return '2종 소형';
    case ContractDriverLicenseType.CLASS_2_MOPED:
      return '2종 원동기';
    default:
      return '';
  }
};

export default ContractDriverLicenseType;
